import Context from "shared/util/Context";

export const PROMO_DESIGN = {
	profilephoto: `profile photo - limit ${Context.get("likesCapTotal")}`,
	whoLikesYouTiles: "who likes you tiles",
	noLikesBoostUpsell: "no likes boost upsell",
};



// WEBPACK FOOTER //
// ./src/analytics/util/queryParamsMap.js